export enum PracticesAction {
  REPLACE_ALL_PRACTICES = 'REPLACE_ALL_PRACTICES'
}

export type PracticeType = {
  gameId: string,
  dsid: string,
  name: string,
  sessionNumber: number,
  endTime: number,
  startTime: number,
  intensity: string,
  aveMaxSpeedMPH: number,
  aveMaxSustainedSpeedMPH: number,
  totalAveDist: number,
  aveHardEffortDist: number,
  totalAveAccels: number,
  totalAveDecels: number,
  homeTeamId: string,
}

export type PracticesState = PracticeType[]

interface ReplaceAllPractices {
  type: PracticesAction.REPLACE_ALL_PRACTICES,
  practices: PracticesState
}

export type PracticesActionTypes = ReplaceAllPractices;